<template>
  <div>
    <SecurityOverviewSummary :timeRange="timeRange" />
    <SecurityOverviewCharts :timeRange="timeRange" />
  </div>
</template>

<script>
import SecurityOverviewCharts from '@/xvisor/components/security/SecurityOverviewCharts.vue';
import SecurityOverviewSummary from '@/xvisor/components/security/SecurityOverviewSummary.vue';

export default {
  components: {
    SecurityOverviewCharts,
    SecurityOverviewSummary,
  },
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>
